import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { SyncTrunk } from 'mobx-sync';
import { createErrorInterceptor, FetchService } from 'src/core';
import { Client } from './generated_client';
import ActionItemsStore from './stores/ActionItemsStore';
import ActionStatusesStore from './stores/ActionStatusesStore';
import AffinityClustersStore from './stores/AffinityClustersStore/AffinityClustersStore';
import AssessmentsStore from './stores/AssessmentsStore/AssessmentsStore';
import BestPracticesStore from './stores/BestPracticesStore';
import BranchesStore from './stores/BranchesStore';
import BranchKpisStore from './stores/BranchKpisStore';
import ChevronsStore from './stores/ChevronStore';
import GlobalStore from './stores/GlobalStore';
import KpisStore from './stores/KpisStore/KpisStore';
import KpiTypesStore from './stores/KpisStore/KpiTypesStore';
import LoginStore from './stores/LoginStore';
import NotificationStore from './stores/NotificationStore';
import ObservationsStore from './stores/ObservationsStore';
import ObservationTypesStore from './stores/ObservationsStore/ObservationTypesStore';
import OrganizationsStore from './stores/OrganizationsStore';
import RegionsStore from './stores/RegionsStore';
import RolesStore from './stores/RolesStore';
import UsersStore from './stores/UsersStore';

interface IStores {
    // BEGIN: STORES INTERFACE -- DO NOT REMOVE
    actionItems: ActionItemsStore;
    actionStatuses: ActionStatusesStore;
    affinityClusters: AffinityClustersStore;
    assessments: AssessmentsStore;
    bestPractices: BestPracticesStore;
    branchKpis: BranchKpisStore;
    branches: BranchesStore;
    chevrons: ChevronsStore;
    global: GlobalStore;
    kpiTypes: KpiTypesStore;
    kpis: KpisStore;
    login: LoginStore;
    notifications: NotificationStore;
    observationTypes: ObservationTypesStore;
    observations: ObservationsStore;
    organizations: OrganizationsStore;
    regions: RegionsStore;
    roles: RolesStore;
    routing: RouterStore;
    users: UsersStore;
    // END: STORES INTERFACE -- DO NOT REMOVE
}

let baseUrl = 'http://localhost:5000';
if (process.env.NODE_ENV === 'production') {
    baseUrl = process.env.REACT_APP_BASE_URL || '';
}
const fetchService = new FetchService();

const routerStore = new RouterStore();
const global = new GlobalStore(routerStore);
const trunk = new SyncTrunk(global);
trunk.init();
const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, routerStore);
const notifications = new NotificationStore();

fetchService.addInterceptor(createErrorInterceptor(global, notifications));
const client = new Client(baseUrl, fetchService);

const login = new LoginStore(global, notifications, routerStore, client);
const assessmentsStore = new AssessmentsStore(global, client, baseUrl);
const stores: IStores = {
    // BEGIN: STORES INSTANCE -- DO NOT REMOVE
    actionItems: new ActionItemsStore(assessmentsStore, global, client, notifications),
    actionStatuses: new ActionStatusesStore(global, client),
    affinityClusters: new AffinityClustersStore(client),
    assessments: assessmentsStore,
    bestPractices: new BestPracticesStore(global, client, notifications),
    branchKpis: new BranchKpisStore(client, notifications),
    branches: new BranchesStore(global, client),
    chevrons: new ChevronsStore(global, client, notifications),
    global,
    kpiTypes: new KpiTypesStore(client),
    kpis: new KpisStore(global, client),
    login,
    notifications,
    observationTypes: new ObservationTypesStore(client),
    observations: new ObservationsStore(global, client, ''),
    organizations: new OrganizationsStore(global, client),
    regions: new RegionsStore(global, client),
    roles: new RolesStore(global, client),
    routing: routerStore,
    users: new UsersStore(global, login, client),
    // END: STORES INSTANCE -- DO NOT REMOVE
};

export default stores;
export { IStores, history };



// WEBPACK FOOTER //
// ./src/Stores.ts